import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-gradient-to-r data-[state=checked]:from-blue-500 data-[state=checked]:to-blue-600 data-[state=checked]:border-blue-400 data-[state=checked]:shadow-lg data-[state=checked]:shadow-blue-500/50",
      "data-[state=unchecked]:bg-gray-700 data-[state=unchecked]:border-gray-600 data-[state=unchecked]:shadow-inner",
      "hover:data-[state=checked]:from-blue-400 hover:data-[state=checked]:to-blue-500 hover:data-[state=unchecked]:bg-gray-600",
      "active:scale-95",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full shadow-lg transition-all duration-300 ease-in-out",
        "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0.5",
        "data-[state=checked]:bg-white data-[state=checked]:shadow-blue-200/50",
        "data-[state=unchecked]:bg-gray-300 data-[state=unchecked]:shadow-gray-900",
        "ring-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
